const STORAGE_KEY = 'bgg-ranking-slots-v1'
const MAX_SLOTS = 12
const MAX_NAME_LEN = 48

/**
 * @typedef {{ id: string, name: string, updatedAt: number, payload: string }} RankSlotRow
 */

/** @returns {RankSlotRow[]} */
export function listRankSlots() {
	if (typeof localStorage === 'undefined') return []
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (!raw) return []
		const arr = JSON.parse(raw)
		return Array.isArray(arr) ? arr : []
	} catch {
		return []
	}
}

/** @param {RankSlotRow[]} slots */
function writeSlots(slots) {
	if (typeof localStorage === 'undefined') return
	localStorage.setItem(STORAGE_KEY, JSON.stringify(slots))
}

/**
 * @param {string} name
 * @param {object} exportObject — output shape of serializeRankExport
 * @returns {string} slot id
 */
export function saveRankSlot(name, exportObject) {
	const trimmed = String(name || '').trim().slice(0, MAX_NAME_LEN)
	if (!trimmed) throw new Error('Enter a name for this slot.')

	const slots = listRankSlots()
	if (slots.length >= MAX_SLOTS) {
		throw new Error(`You can store at most ${MAX_SLOTS} slots. Delete one to add another.`)
	}

	const id =
		typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
			? crypto.randomUUID()
			: `slot_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`

	const payload = typeof exportObject === 'string' ? exportObject : JSON.stringify(exportObject)
	slots.push({ id, name: trimmed, updatedAt: Date.now(), payload })
	writeSlots(slots)
	return id
}

/** @param {string} id */
export function deleteRankSlot(id) {
	const next = listRankSlots().filter((s) => s.id !== id)
	writeSlots(next)
}

/**
 * @param {string} id
 * @returns {object|null}
 */
export function getSlotPayloadObject(id) {
	const slot = listRankSlots().find((s) => s.id === id)
	if (!slot) return null
	try {
		return JSON.parse(slot.payload)
	} catch {
		return null
	}
}
